import { QueryResource } from 'datx-jsonapi-react';

import { LectureVotes } from '@/resources/LectureVotes';
import { ThinLecture } from '@/resources/ThinLecture';

export const queryLectureVote = (lectureId: string): QueryResource<LectureVotes> => {
  if (!lectureId) return null;
  return [ThinLecture.type, `${lectureId}/vote`];
};
